//import firebase from "firebase";
//import firebaseConfig from "../config/firebase";'
import firebase from "firebase/app";
// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyAdYYpjrVJtX0kAcsYhXap2Hit2RCSHo00",
  authDomain: "ioloc-dev.firebaseapp.com",
  databaseURL:
    "https://ioloc-dev-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ioloc-dev",
  storageBucket: "ioloc-dev.appspot.com",
  messagingSenderId: "884450819364",
  appId: "1:884450819364:web:439e8a18a23ef0c76307b1",
};

// Import the functions you need from the SDKs you need

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
